
import { getEcCom } from '../convert';
import base from "../base";
import { isEqual, cloneDeep } from "lodash";
//字段变更类型 
export const TYPE_MAIN_INIT = "1";        //主表字段初始值加载
export const TYPE_DETAIL_ADDROW = "2";    //添加/生成明细行的默认值
export const TYPE_FIELD_CHANGE = "3";     //手动变更字段
export const TYPE_LINKAGE_SYNC = "4";     //同步联动修改
export const TYPE_LINKAGE_ASYNC = "5";    //异步联动修改
export const TYPE_WFFORM_API = "6";       //通过接口WfForm修改(包括公式)
export const CHANGE_FIELD_VALUE = "c_value";    //改变字段值
export const CHANGE_FIELD_VARS = "c_vars";      //改变字段属性

/**
 *
 */
export const setDocParam = async (odocInfo) => {
  const docInfonew = odocInfo;
  if (docInfonew.docParam && !docInfonew.docParam.authStr) {
    docInfonew.docParam.authStr = wfform.getGlobalStore().commonParam.authStr;
  }
  if (docInfonew.docParam && !docInfonew.docParam.authSignatureStr) {
    docInfonew.docParam.authSignatureStr = wfform.getGlobalStore().commonParam.authSignatureStr;
  }
  if (docInfonew.docParam && !docInfonew.docParam.f_weaver_belongto_userid) {
    docInfonew.docParam.f_weaver_belongto_userid = wfform.getBaseInfo().f_weaver_belongto_userid;
  }
  if (docInfonew.docParam && !docInfonew.docParam.f_weaver_belongto_usertype) {
    docInfonew.docParam.f_weaver_belongto_usertype = wfform.getBaseInfo().f_weaver_belongto_usertype;
  }

  await loadMouldInfoByField();
  const editOrShowMouldfieldid = "field" + docInfonew.docParam.editMouldFieldid + "," + "field" + docInfonew.docParam.showMouldFieldid;
  WfForm.bindFieldChangeEvent(editOrShowMouldfieldid, (obj, id, value) => {
    loadMouldInfoByField();
  });


  const formFieldList = docInfonew.formFieldList;
  const fieldTotalList = new Array();
  //编辑模板字段
  for (let i = 0; formFieldList && i < formFieldList.length; i++) {
    const fieldid = formFieldList[i];
    if (jQuery.inArray(fieldid, fieldTotalList) >= 0) continue;
    fieldTotalList.push(fieldid);
  }
  //选择框字段
  if (jQuery.inArray(docInfonew.docParam.secFieldid, fieldTotalList) == -1) {
    fieldTotalList.push(docInfonew.docParam.secFieldid);
  }
  //编辑模板字段
  if (jQuery.inArray(docInfonew.docParam.editMouldfieldid, fieldTotalList) == -1) {
    fieldTotalList.push(docInfonew.docParam.editMouldFieldid);
  }
  //套红模板字段
  if (jQuery.inArray(docInfonew.docParam.showMouldFieldid, fieldTotalList) == -1) {
    fieldTotalList.push(docInfonew.docParam.showMouldFieldid);
  }
  //文档标题
  if (jQuery.inArray(docInfonew.docParam.documentTitleField, fieldTotalList) == -1) {
    fieldTotalList.push(docInfonew.docParam.documentTitleField);
  }

  const fieldTotalObj = getFromFieldValue(fieldTotalList);
  //保留需要带入URL参数的内容
  docInfonew.nowDocParam = new Object();
  docInfonew.nowDocParam = cloneDeep(mobx.toJS(docInfonew.docParam));
  for (let fieldInfo in fieldTotalObj) {//不使用过滤
    docInfonew.nowDocParam[fieldInfo] = fieldTotalObj[fieldInfo];
  }

  //模板书签对应字段
  const formFieldObj = getFromFieldValue(formFieldList ? formFieldList : []);
  //模板书签对应，不需要带入URL参数中，但是需要记录变化
  for (let fieldInfo in formFieldObj) {
    docInfonew.nowDocParam[fieldInfo] = formFieldObj[fieldInfo];
  }

  //是否需要重新加载url
  docInfonew.needReload = false;
  if (!isEqual(mobx.toJS(docInfonew.nowDocParam), mobx.toJS(docInfonew.lasttimeDocParam))) {
    docInfonew.needReload = true;
    //开启默认预览正文，且点了编辑按钮之后，不做重新加载
    if (docInfonew.docParam.useyozoorwps == "1" && docInfonew.docParam.onEditDoc == true) {
      docInfonew.needReload = false;
    }
    docInfonew.lasttimeDocParam = new Object();
    docInfonew.lasttimeDocParam = cloneDeep(mobx.toJS(docInfonew.nowDocParam));
  } else {
    docInfonew.needReload = false;
  }

  WfForm.changeOdocConfig(docInfonew);
  if (docInfonew.needReload) {
    let url = docInfonew.docUrl + "?";
    let count = 0;
    let router = docInfonew.docParam.router;
    if (docInfonew.docParam.isEdit == 1) {
      router = "#/main/document/edit";
    } else {
      router = "#/main/document/detail";
    }
    for (let key in docInfonew.docParam) {
      if (key == "router") continue;
      if (!(docInfonew.docParam[key])) continue;
      if (count > 0) url += "&";
      url += key + "=" + encodeURIComponent(docInfonew.docParam[key]);
      count++;
    }
    const dataJson = cloneDeep(mobx.toJS(docInfonew.nowDocParam));
    dataJson.action = 'setUrlParams';
    const { WeaTools } = getEcCom();
    const result = await WeaTools.callApi('/api/odoc/odocWorkflow/setUrlParams?date=' + new Date().getTime(), 'POST', { ...dataJson });
    if (result.success) {
      url += "&uuid=" + result.uuid;
    }
    url += router;
    try {
      document.getElementsByClassName("req-workflow-odoc")[0].contentWindow.onbeforeunload = null;
    } catch (e) {
    }
    base.globalStore.odocIframeUrl = getSecondPath(url);
    docInfonew.iframeUrl = getSecondPath(url);
    odocInfo = docInfonew;
  }
}


//根据模板区分字段，获取编辑、套红模板信息
export const loadMouldInfoByField = async () => {
  const docInfo = WfForm.getOdocConfig();
  const { editMouldFieldid, showMouldFieldid, isSelectField, isShowSelectField, workflowid, requestid,selectFieldType=0 } = docInfo.docParam
  //获取编辑模板对应字段选择模板
  const newEditMouldfieldid = editMouldFieldid == -1 ? -1 : "field" + editMouldFieldid;
  //获取套红模板对应字段选择模板
  const newShowMouldfieldid = showMouldFieldid == -1 ? -1 : "field" + showMouldFieldid;

  let editfieldvalue = -1;
  if (newEditMouldfieldid != -1) {
    editfieldvalue = WfForm.getFieldValue(newEditMouldfieldid);
    if (isSelectField == 'false' && editfieldvalue != "") {
      editfieldvalue = Number(editfieldvalue) + 100;
    }
  }
  let showfieldvalue = -1;
  if (newShowMouldfieldid != -1) {
    showfieldvalue = WfForm.getFieldValue(newShowMouldfieldid);
    if (isShowSelectField == 'false' && showfieldvalue != "") {
        if(selectFieldType==324){
            showfieldvalue = -1*Number(showfieldvalue) - 100;
        }else {
            showfieldvalue = Number(showfieldvalue) + 100;
        }

    }
  }
  const { WeaTools } = getEcCom();
  const params = {
    workflowid,
    editfieldvalue,
    showfieldvalue,
    selectFieldType,
    requestid,
    action: "getMouldInfo"
  }
  const res = await WeaTools.callApi('/odoc/docs/odocCommonAjax.jsp', "POST", params)
  docInfo.docParam = {
    ...docInfo.docParam,
    editmouldCount: res.editmouldCount,
    showmouldCount: res.showmouldCount,
    editMouldId: res.editMouldId,
    showMouldId: res.showMouldId,
    formFieldList: res.formFieldList,
    onlyOfficeEditor: res.onlyOfficeEditor
  }
}

export const getFromFieldValue = (fieldList) => {
  var retObj = new Object();
  for (var i = 0; i < fieldList.length; i++) {
    var fieldid = fieldList[i];
    if (fieldid == "-3") {
      var fieldvalue = WfForm.getFieldValue("field-1");
      retObj["requestname"] = fieldvalue;
    } else {
      var fieldvalue = WfForm.getFieldValue("field" + fieldid);
      retObj["field" + fieldid] = fieldvalue;
    }
  }
  retObj["requestname"] = WfForm.getFieldValue("field-1");
  return retObj;
}
//获取二级路径
export const getSecondPath = (url) => {
  const ecologyContentPath = window.ecologyContentPath || '';//二级路径
  if (ecologyContentPath != "" && url && url != "") {
    if (url.indexOf("/") == 0 && url.indexOf(ecologyContentPath) != 0) {
      url = ecologyContentPath + url;
    } else if (url.indexOf("http") == 0) {
      let origin = window.location.origin;
      if (!origin) {
        origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
      }
      if (url.indexOf(origin) == 0 && url.indexOf(origin + ecologyContentPath) != 0) {
        url = url.replace(origin, origin + ecologyContentPath);
      }
    }
  }
  return url;
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/util/public/odocUtil.js